/**
 * Fetches the file size in bytes from a given URL by making a HEAD request.
 *
 * This function appends a dummy query parameter to the URL to bypass browser caching.
 * There may be events where the file may already be fetched in the DOM for things like
 * img, audio, and video. Even if it's metadata, some browsers will cache the response
 * headers. Then when this function tries to fetch it will encounter cached headers,
 * which might not include the necessary CORS headers, leading to CORS errors.
 *
 * A dummy caching busting query parameter to the URL, so we ensure that each request
 * is treated as a new request by the browser, bypassing the cache and fetching
 * fresh headers from the server.
 *
 * @param url - The URL of the file to fetch the size for.
 * @returns The file size in bytes, or null if the size could not be determined.
 */
export const getFileSizeBytesFromUrl = async (url: string): Promise<number | null> => {
  try {
    // using current timestamp for dummy cache buster to allow unique request each time
    const response = await fetch(`${url}?t=${Date.now()}`, { method: 'HEAD' });
    const contentLength = Number(response?.headers?.get('content-length'));
    return contentLength || null;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return null;
  }
};
